// Action types for redux

// This action is for updating a field inside the config object
export const UPDATE_FIELD = "UPDATE_FIELD";
export const SET_CONFIG = "SET_CONFIG";
export const RESET_CONFIG = "RESET_CONFIG";
export const RESET_FILES = "RESET_FILES";

// For updating the files array
export const UPDATE_FILE = "UPDATE_FILE";

// For updating a generic state attribute
export const UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE";

export const UPDATE_OVERLAYIMAGE ="UPDATE_OVERLAYIMAGE"; 
export const UPDATE_GREENSCREENBACK ="UPDATE_GREENSCREENBACK"; 
export const UPDATE_GAME ="UPDATE_GAME"; 
export const SAVE_CONFIG = "SAVE_CONFIG";
